import { useTranslation } from 'react-i18next';

import PageTitle from '../../shared/PageTitle/PageTitle';
import { POLICIES, PRIVACY_POLICIES } from '../../routes/paths';
import LinkButton from '../../components/forms/Button/LinkButton';

import styles from './styles.module.scss';
import { useLocalizedPath } from '../../seo/useLocalizedPath';

const PoliciesPage = () => {
  const { t } = useTranslation();
  const localizePath = useLocalizedPath();

  return (
    <div className={styles.policiesPage}>
      <div className="container">
        <PageTitle weight="normal">{t("storePolicies")}</PageTitle>
        <div className={styles.content}>
          <LinkButton
            href={localizePath(`${POLICIES}${PRIVACY_POLICIES}`)}
            label="Privacy Policy"
          />
        </div>
      </div>
    </div>
  );
};

export default PoliciesPage;
